exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".baseForm[data-v-51aaa03d] .el-input {\n  width: 250px !important;\n}\n", ""]);

// exports
